import { SkeletonLoader } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorBoundaryWrapper } from '~/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { useDocumentSections } from '~/react-query-hooks/documents/useDocumentsEntity';
import { POSTHOG_TRACKING_SOURCES } from '~/services/tracking/posthog/constants';
import { CitationsAccordionWidget } from '~/widgets/citations-accordion-widget/CitationsAccordionWidget';

import * as S from './GeoSourceEvidenceSection.styles';

interface GeoSourceEvidenceSectionProps {
  evidence?: string[] | null;
  sourceEvidence?: string | null;
}

export const GeoSourceEvidenceSection = ({
  evidence,
  sourceEvidence,
}: GeoSourceEvidenceSectionProps) => {
  const { t } = useTranslation(['widget']);
  const { data, isFetching, isError } = useDocumentSections(evidence ?? []);

  if (isError) {
    throw new Error('GeoSourceEvidenceSection error');
  }

  if (!sourceEvidence && !data.length && !isFetching) {
    return null;
  }

  return (
    <S.SectionRow>
      <S.TitleBase>
        {t(
          'widget:assetOverview.knowledgeGraph.themeExposure.tabs.themeExposure.sourceEvidence'
        )}
      </S.TitleBase>
      <ErrorBoundaryWrapper>
        <>
          {isFetching ? (
            <SkeletonLoader
              data-testid="loading-skeleton"
              areas={[
                {
                  styles: {
                    width: '100%',
                    height: '180px',
                    borderRadius: '8px',
                  },
                },
              ]}
            />
          ) : (
            <>
              {sourceEvidence && (
                <S.BodySmall data-testid="evidence">
                  {sourceEvidence}
                </S.BodySmall>
              )}
              <CitationsAccordionWidget
                citations={data}
                trackingMetadata={{
                  source: POSTHOG_TRACKING_SOURCES.COMPANY_TO_GEO_DRAWER,
                }}
              />
            </>
          )}
        </>
      </ErrorBoundaryWrapper>
    </S.SectionRow>
  );
};
